import { Field } from 'Util/Query';

/** @namespace Hoeks/UpcomingBike-Form/Query/BikeForm/Query/BikeFormQuery */
export class BikeFormQuery {
    subscribeEmailToUpcomingBike(data) {
        // TODO implement query
        return new Field('subscribeEmailToUpcomingBike')
        .addArgument('name', 'String!', data.name)
        .addArgument('email', 'String!', data.email)
        .addArgument('country', 'String!', data.country)
        .addArgument('use_it_for', 'String!', data.use_it_for)
        .addArgument('interested_in', 'String!', data.interested_in)
        .addArgument('company_name', 'String', data.company_name)
        .addArgument('subscribed_to_newsletter', 'Int!', data.subscribed_to_newsletter)
        .addField('status')
        .addField('message')
    }
}

export default new BikeFormQuery();
